import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { ModalComponent } from "../components/modal.component";
import { NavPillsComponent } from "../components/nav-pills.component";
import { PageMenuComponent } from "../components/page-menu.component";
import { RadioGroupComponent } from "../components/radio-group.component";
import { ImageCheckboxComponent } from "../components/image-checkbox.component";
import { DropdownComponent } from "../components/dropdown.component";
import { DropdownMultiselectComponent } from "../components/dropdown-multiselect.component";
import { LanguagesComponent } from "../components/languages.component";
import { DateTimePickerComponent } from "../components/date-time-picker.component";
import { SampleTypeComponent } from "../components/sample-type.component";
import { SwitchButtonComponent } from "../components/switch-button.component";

import { SubsampleStatusButtonComponent } from "../components/subsample-status-button.component";
import { CortexRedirectorComponent } from "../components/cortex-redirector.component";
import { FezaRedirectorComponent } from "../components/feza-redirector.component";
import { AutocompleteComponent } from "../components/autocomplete.component";


import { JqueryExtensionsService } from "../services/jquery.service";
import { DatexPipe } from "../pipes/datex.pipe";
import { DateformatPipe } from "../pipes/dateformat.pipe";
import { TrimPipe } from "../pipes/trim.pipe";
import { CapitalizePipe } from "../pipes/capitalize.pipe";
import { GroupByPipe } from "../pipes/groupBy.pipe";
import { RoundPipe } from "../pipes/round.pipe";
import { ResearchTypeFilterPipe } from "../pipes/research-type-filter.pipe";
import { CurrencySymbolPipe } from "../pipes/currency-symbol.pipe";
import { SupplierBillingStatePipe } from "../pipes/supplier-billing-state.pipe";
import { SupplierBillingStateDisableInputPipe } from "../pipes/supplier-billing-state-disable-input.pipe";
import { NumberSignPipe } from "../pipes/number-sign.pipe";
import { TextColorClassPipe } from "../pipes/text-color-class.pipe";
import { SupplierDiscountPercentPipe } from "../pipes/supplier-discount-percent.pipe";
import { SubsampleFieldLoiPipe } from "../pipes/subsample-field-loi.pipe";
import { EstimatedCPIColorPipe } from "../pipes/estimated-cpi-color.pipe";
import { SubsampleFieldIncidencePipe } from "../pipes/subsample-field-incidence.pipe";
import { IdValuePipe} from "../pipes/id-value.pipe";
import { Switch3StateComponent } from "../components/switch-3state/switch-3state.component";
import { ReplaceLineBreak } from "../pipes/replace-line-break.pipe";

let sharedComponents: Array<any> = [
	ModalComponent,
	NavPillsComponent,
	PageMenuComponent,
	ImageCheckboxComponent,
	RadioGroupComponent,
	DropdownComponent,
	DropdownMultiselectComponent,
	LanguagesComponent,
	SampleTypeComponent,
	SwitchButtonComponent,
	DateTimePickerComponent,
	SubsampleStatusButtonComponent,
	CortexRedirectorComponent,
	AutocompleteComponent,
    DatexPipe,
    DateformatPipe,
    TrimPipe,
    CapitalizePipe,
    GroupByPipe,
    ResearchTypeFilterPipe,
    RoundPipe,
    FezaRedirectorComponent,
    CurrencySymbolPipe,
    SupplierBillingStatePipe,
    SupplierBillingStateDisableInputPipe,
    NumberSignPipe,
    TextColorClassPipe,
    SupplierDiscountPercentPipe,
    SubsampleFieldLoiPipe,
    EstimatedCPIColorPipe,
    SubsampleFieldIncidencePipe,
    IdValuePipe,
    Switch3StateComponent,
    ReplaceLineBreak
    ];

@NgModule({
	imports: [CommonModule, FormsModule],
	declarations: sharedComponents,
	exports: sharedComponents,
	providers: [JqueryExtensionsService]
})
export class BootstrapSharedModule { }
